if (!customElements.get('size-guide-section')) {
  class SizeGuideSection extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      if (this.childElementCount) {
        this.initializeSizeGuideToggle();

        return;
      }

      // Fetch and append size-guide content
      fetch('/pages/size-guide')
        .then(response => response.text())
        .then(html => {
          const tempDiv = document.createElement('div');
          tempDiv.innerHTML = html;

          const sizeGuideSection = tempDiv.querySelector('size-guide-section');

          this.innerHTML = sizeGuideSection.innerHTML;
          this.initializeSizeGuideToggle();
        })
        .catch(error => console.error('Error fetching size guide:', error));
    }

    initializeSizeGuideToggle() {
      const modal = this.querySelector('#sizeGuideModal');
      const btn = document.querySelector('#sizeGuideBtn');
      const closeBtn = this.querySelector('#closeModalBtn');
      const toggleCm = this.querySelector('#toggleCm');
      const toggleFt = this.querySelector('#toggleFt');
      const cmColumns = this.querySelectorAll('.measurement-cm');
      const ftColumns = this.querySelectorAll('.measurement-ft');

      // Adds a listener for any link with the '#size-guide' href to open the size guide
      document.querySelectorAll('a[href="#size-guide"]').forEach(link => {
        link.addEventListener('click', event => {
          event.preventDefault();
          modal.classList.remove('hidden');
        });
      });

      // Default to ft view
      cmColumns.forEach(col => col.classList.add('hidden'));
      ftColumns.forEach(col => col.classList.remove('hidden'));

      // Modal control
      btn?.addEventListener('click', () => modal.classList.remove('hidden'));
      closeBtn?.addEventListener('click', () => modal.classList.add('hidden'));
      modal?.addEventListener('click', event => {
        if (event.target === modal) modal.classList.add('hidden');
      });

      // Toggle measurement buttons
      toggleCm?.addEventListener('click', () => {
        cmColumns.forEach(col => col.classList.remove('hidden'));
        ftColumns.forEach(col => col.classList.add('hidden'));
        // Update button styles
        toggleCm.classList.add('bg-primary-1', 'text-white');
        toggleCm.classList.remove('bg-gray-200', 'text-black'); // Ensure the text is black
        toggleFt.classList.remove('bg-primary-1', 'text-white');
        toggleFt.classList.add('bg-gray-200', 'text-black'); // Ensure the text is black
      });

      toggleFt?.addEventListener('click', () => {
        ftColumns.forEach(col => col.classList.remove('hidden'));
        cmColumns.forEach(col => col.classList.add('hidden'));
        // Update button styles
        toggleFt.classList.add('bg-primary-1', 'text-white');
        toggleFt.classList.remove('bg-gray-200', 'text-black'); // Ensure the text is black
        toggleCm.classList.remove('bg-primary-1', 'text-white');
        toggleCm.classList.add('bg-gray-200', 'text-black'); // Ensure the text is black
      });
    }
  }

  // Define the custom element
  customElements.define('size-guide-section', SizeGuideSection);
}
